module.exports = __webpack_public_path__ + "img/lipic1.169ea6e1.svg";